import { format, parseISO } from "date-fns";

/** Advances an ISO date string by the result of `mutate`. Returns the original string unchanged if it is empty or invalid. */
export function bumpDate(current, mutate) {
  if (!current) return current;
  var base = parseISO(current);
  if (isNaN(base.getTime())) return current;
  return format(mutate(base), "yyyy-MM-dd");
}